export default "__VITE_ASSET__O6Ts1pJG__"